var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(function () { return _vm.value; }),expression:"() => value"}],attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.$Notice.info({
      title: _vm.$t('COPIED_IN_CLIPBOARD'),
      duration: 1.5
    })}}},[_c('fa',{attrs:{"icon":"copy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }